import React, { Component } from 'react';
import Icon from '../../artzu-ui/src/Icon';
import Button from '../../artzu-ui/src/Button';
import MediaQuery from 'react-responsive';
import { Redirect } from 'react-router-dom';
import SideBarContent from '../SideBar/SideBarContent';
import { Link } from 'react-router-dom';
import gql from 'graphql-tag';
import { m } from '../../utils';
import { Query } from 'react-apollo';
import Loading from '../shared/Loading';
import HeatMap from './HeatMap';
import HeatMapLegend from './HeatMapLegend';
import './index.css';

const query = gql`
  query currentDriver {
    currentUser {
      id
      accessibleVehicleClasses
      parkinglots {
        id
        city
        region
      }
    }
  }
`;

class PriceMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicleClass: null,
      startDate: m()
        .clone()
        .startOf('isoWeek'),
      stretch: 7,
      rates: {
        pro: ['$6.00', '$6.50', '$7.00', 'Full'],
        plus: ['$4.00', '$4.50', '$5.00', 'Full'],
        go: ['$7.00', '$8.00', '$9.00', 'Full']
      },
      shifts: [3, 7, 11, 15, 19, 23],
      parkinglotId: null
    };
  }

  navigateWeek = direction => {
    const { startDate } = this.state;
    if (direction === 'next') {
      this.setState({ startDate: startDate.clone().add(1, 'week') });
    } else {
      this.setState({ startDate: startDate.clone().subtract(1, 'week') });
    }
  };

  handleTierChange = vehicleClass => {
    this.setState({ vehicleClass });
  };

  handleParkinglotChange = parkinglotId => {
    this.setState({ parkinglotId });
  };

  formatShift = shiftHour => {
    return `${shiftHour % 12}${shiftHour / 12 < 1 ? 'am' : 'pm'}`;
  };

  bgcColour = (price, tier) => {
    switch (tier) {
      case 'pro':
        switch (price) {
          case 6:
          case '$6.00':
            return '#128dff';
          case 6.5:
          case '$6.50':
            return '#00519d';
          case 7:
          case '$7.00':
            return '#001f3c';
          default:
            return '#dedede';
        }
      case 'plus':
        switch (price) {
          case 4:
          case '$4.00':
            return '#128dff';
          case 4.5:
          case '$4.50':
            return '#00519d';
          case 5:
          case '$5.00':
            return '#001f3c';
          default:
            return '#dedede';
        }
      case 'go':
        switch (price) {
          case 7:
          case '$7.00':
            return '#128dff';
          case 8:
          case '$8.00':
            return '#00519d';
          case 9:
          case '$9.00':
            return '#001f3c';
          default:
            return '#dedede';
        }
    }
  };

  // generateWeek = () => {
  //   const {
  //     startDate,
  //     stretch
  //   } = this.state;
  // }

  render() {
    const { status, loggedIn, history } = this.props;
    const {
      vehicleClass,
      startDate,
      stretch,
      rates,
      shifts,
      parkinglotId
    } = this.state;
    if (['blacklisted'].includes(status))
      return <Redirect to="/profile" />;
    return (
      <Query query={query}>
        {({ loading, error, data, refetch }) => {
          if (loading)
            return (
              <div className="load-div">
                <Loading size="3x" />
              </div>
            );
          if (error) return <Redirect to="/" />;
          return window.innerWidth < 768 ? (
            <Redirect to="/downloadapp" />
          ) : (
            <div className="price-map container">
              <MediaQuery minWidth={768}>
                <div className="desktop-subheader">
                  Pricing
                  <Button
                    label="Book"
                    className="dash-book-button"
                    padding="0"
                    margin="0"
                    primary
                    onClick={() => history.push('/book')}
                  />
                </div>
                <div className="sidebar-container">
                  <SideBarContent status={status} signedIn={loggedIn} />
                </div>
              </MediaQuery>
              <MediaQuery maxWidth={767}>
                <div className="price-header">
                  <a
                    onClick={e => {
                      e.preventDefault();
                      history.push('/dashboard');
                    }}>
                    <Icon size="sm" name="BackArrow" color="#414141" />
                  </a>
                  <p>Pricing</p>
                  <div></div>
                </div>
              </MediaQuery>
              <div className="scrollable-content">
                <div className="price-area">
                  <div className="tier-nav">
                    {data.currentUser.parkinglots.map(
                      (parkinglot, index) => {
                        return (
                          <Button
                            key={index}
                            className="tier-heat"
                            label={
                              parkinglot.region[0].toUpperCase() +
                              parkinglot.region.slice(1)
                            }
                            primary={
                              parkinglotId === parkinglot.id ||
                              (parkinglotId === null && index === 0)
                            }
                            color="#414141"
                            margin="0 0.5em 0 0"
                            padding="0"
                            onClick={() =>
                              this.handleParkinglotChange(parkinglot.id)
                            }
                          />
                        );
                      }
                    )}
                  </div>
                  <div className="tier-nav">
                    {data.currentUser.accessibleVehicleClasses.map(
                      (tier, index) => {
                        return (
                          <Button
                            key={index}
                            className="tier-heat"
                            label={tier.toUpperCase()}
                            primary={
                              vehicleClass === tier ||
                              (vehicleClass === null && index === 0)
                            }
                            color="#414141"
                            margin="0 0.5em 0 0"
                            padding="0"
                            onClick={() => this.handleTierChange(tier)}
                          />
                        );
                      }
                    )}
                  </div>
                  <HeatMap
                    navigateWeek={this.navigateWeek}
                    vehicleClass={
                      vehicleClass ||
                      data.currentUser.accessibleVehicleClasses[0]
                    }
                    startDate={startDate}
                    stretch={stretch}
                    bgcColour={this.bgcColour}
                    formatShift={this.formatShift}
                    shifts={shifts}
                    parkinglotId={
                      parseInt(parkinglotId) ||
                      parseInt(data.currentUser.parkinglots[0].id)
                    }
                  />
                </div>
                <HeatMapLegend
                  rates={
                    rates[
                      vehicleClass ||
                        data.currentUser.accessibleVehicleClasses[0]
                    ]
                  }
                  bgcColour={this.bgcColour}
                  vehicleClass={
                    vehicleClass ||
                    data.currentUser.accessibleVehicleClasses[0]
                  }
                />
              </div>
              <div className="pricing-footer">
                <Button
                  label="Book Now"
                  className="book-now"
                  padding="0"
                  margin="0"
                  primary
                  onClick={() => history.push('/book')}
                />
              </div>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default PriceMap;



// WEBPACK FOOTER //
// ./src/components/PriceMap/index.js